import api from '../config/api';

const brandService = {
  async getAll() {
    const response = await api.get('/api/admin/brands');
    return response.data;
  },

  async getById(id) {
    const response = await api.get(`/api/admin/brands/${id}`);
    return response.data;
  },

  async create(brandData) {
    const response = await api.post('/api/admin/brands/create', brandData);
    return response.data;
  },

  async update(id, brandData) {
    const response = await api.post(`/api/admin/brands/${id}/update`, brandData);
    return response.data;
  },

  async delete(id) {
    const response = await api.post(`/api/admin/brands/${id}/delete`);
    return response.data;
  },
};

export default brandService;
